import { css } from '@emotion/css';

export const THS = css`
    font-weight: bold;
`;

export const RED = css`
    color: red;
`;